<template>
  <div>
      <Initialize v-if="selectTab == 0" @disableTab="disableTab" @enableTab="enableTab($event)" />
      <Detect v-if="selectTab == 1" ></Detect>
      <ListKeyStore v-if="selectTab == 2" @enableTab="enableTab($event)" @setKeystore="keyStoreIds= $event" />
      <KeystoreInfo v-if="selectTab == 3" @enableTab="enableTab($event)" :keyStoreIds="keyStoreIds" @setKeyStoreId="keyStoreId = $event" @setKeyStoreInfo="keyStoreInfo = $event"/>
      <GenerateCSR v-if="selectTab == 4" @enableTab="enableTab($event)" :keyStoreIds="keyStoreIds" :keyStoreInfo="keyStoreInfo" :keyStoreId="keyStoreId" @setConfig="config = $event"  @setCSR="setCSR($event)" :data="data"/>
      <GenerateCertificate v-if="selectTab == 5" @enableTab="enableTab($event)" @setPKCS7="setPKCS7($event)" :csr="csr"/>
      <InstallCertificate v-if="selectTab == 6" @enableTab="enableTab($event)" :config="config" :data="data" :pkcs7="pkcs7"/>
      <CertificateList v-if="selectTab == 7" @enableTab="enableTab($event)" @setCertificateList="setListCertificates($event)"/>
      <Sign v-if="selectTab == 8" :certList="certList"/>
      <SignServer v-if="selectTab == 18"/>
      <TestGui v-if="selectTab == 9"/>
      <GuiPlayground v-if="selectTab == 19"/>
      <Diagnosis v-if="selectTab == 10" @disableTab="disableTab" @enableTab="enableTab($event)" />
      <ListProfile v-if="selectTab == 11" @enableTab="enableTab($event)" @setListProfiles="setListProfiles($event)"/>
      <ImportCertificate v-if="selectTab == 12" @enableTab="enableTab($event)" :config="config" :data="data" :certificateSelector="{ keystoreId: 'PFX', profileName: '-Select-' }"/>
      <InitializeProfile v-if="selectTab == 13" @enableTab="enableTab($event)" :keyStoreIds="keyStoreIds" :keyStoreInfo="keyStoreInfo" :keyStoreId="keyStoreId" :data="data"/>
      <ServerConfigManager v-if="selectTab == 14" @enableTab="enableTab($event)" :config="config" :data="data" :serverConfig="serverConfig" @setServerConfig="setServerConfig($event)"/>
      <CreateCredential v-if="selectTab == 15" @enableTab="enableTab($event)" :serverConfig="serverConfig" @setServerConfig="setServerConfig($event)"/>
      <AddSecondFactors v-if="selectTab == 16" @enableTab="enableTab($event)" :serverConfig="serverConfig" @setServerConfig="setServerConfig($event)"/>
      <AddCertificate v-if="selectTab == 17" @enableTab="enableTab($event)" :serverConfig="serverConfig" @setServerConfig="setServerConfig($event)" @setCSR="setCSR($event)" :pkcs7="pkcs7" :csr="csr"/>
      <AlisonServerTests v-if="selectTab == 20" :serverConfig="serverConfig"/>
      <DigilogixView v-if="selectTab == 21" :serverConfig="serverConfig"/>

    <Snackbar />
  </div>
</template>
<script>
import GenerateCSR from './components/GenerateCSR';
import InstallCertificate from './components/InstallCertificate';
import ImportCertificate from './components/ImportCertificate';
import GenerateCertificate from './components/GenerateCertificate';
import CertificateList from './components/ListCertificates';
import ListKeyStore from './components/ListKeyStores';
import ListProfile from './components/ListProfiles';
import KeystoreInfo from './components/KeystoreInfo';
import InitializeProfile from './components/InitializeProfile';
import Sign from './components/GenerateSignature.vue';
import SignServer from './components/SignServer.vue';
import Initialize from './components/InitializeAlisonDesktop.vue';
import Detect from './components/DetectAlisonDesktop.vue';
import Snackbar from './components/SnackBar.vue';
import TestGui from './components/TestGui';
import GuiPlayground from './components/GuiPlayground.vue';
import Diagnosis from './components/DiagAlisonDesktop.vue';

import * as testingDatas from '@/datas/testingDatas.js';
import ServerConfigManager from './components/ServerConfigManager';
import CreateCredential from './components/CreateCredential';
import AddSecondFactors from './components/AddSecondFactors';
import AddCertificate from './components/AddCertificate';
import AlisonServerTests from './components/AlisonServerTests';
import DigilogixView from './components/DigilogixView.vue';

export default {
  components: {
    Snackbar,
    GenerateCSR,
    ImportCertificate,
    InstallCertificate,
    GenerateCertificate,
    CertificateList,
    ListKeyStore,
    Sign,
    SignServer,
    KeystoreInfo,
    Initialize,
    InitializeProfile,
    Detect,
    TestGui,
    GuiPlayground,
    Diagnosis,
    ListProfile,
    ServerConfigManager,
    AddSecondFactors,
    CreateCredential,
    AddCertificate,
    AlisonServerTests,
    DigilogixView,
  },
  props: {
    selectTab: {
      type: Number,
      default: 0
    }
  },
  emits: ['enableTab', 'disableTab'],
  data () {
    return {
      config: null,
      serverConfig: null,
      alisonSdk: null,
      data: null,
      csr: null,
      pkcs7: null,
      keyStoreIds: [],
      keyStoreInfo: [],
      profiles: [],
      keyStoreId: '',
      certList: [],
    }
  },
  created(){
    this.data = testingDatas
  },
  methods: {
    setServerConfig(config) {
      this.serverConfig = { ...this.serverConfig,  ...config };
    },
    setCSR(csr){
      this.csr = csr;
    },
    setPKCS7(pkcs7){
      this.pkcs7 = pkcs7;
    },
    disableTab(){
      this.$emit('disableTab')
    },
    enableTab(values){
      this.$emit('enableTab', values)
    },
    setListProfiles(_profiles) {
      this.profiles=_profiles
    },
    setListCertificates(cert) {
      this.certList=cert
    }
  }
}
</script>
